import React from 'react';
import MuiAlert from '@material-ui/lab/Alert';
import MuiAlertTitle from '@material-ui/lab/AlertTitle';

export const getErrorMessage = (error: Error | string): string => (error instanceof Error ? error.message : error);

export const getErrorsText = (error: Error | Error[] | string | string[]): string =>
  error
    ? Array.isArray(error)
      ? (error as Array<Error | string>).map(getErrorMessage).join('. ')
      : getErrorMessage(error)
    : 'Something went wrong.';

export const getErrorsArray = (error: Error | Error[] | string | string[]): string[] =>
  error
    ? Array.isArray(error)
      ? (error as Array<Error | string>).map(getErrorMessage)
      : [getErrorMessage(error)]
    : ['Something went wrong.'];

interface Props {
  title: string;
  error: Error | Error[] | string | string[];
}

export const ErrorNotification: React.FC<Props> = ({ title, error }: Props) => {
  const errors = getErrorsArray(error);
  return (
    <MuiAlert severity="error">
      <MuiAlertTitle>{title}</MuiAlertTitle>
      {errors.length > 1 ? (
        <ul>
          {errors.map((message, index) => (
            <li key={index}>{message}</li>
          ))}
        </ul>
      ) : (
        errors[0]
      )}
    </MuiAlert>
  );
};
